export default class FeatureFlagIds {
    static readonly REQUIRE_AUTHENTICATION = "require_authentication";
    static readonly VALUATION_BLOCKLIST = "valuation_blocklist";
    static readonly SAMPLE_REPORT_DESIGN = "sample_report_design";
    static readonly REPORT_PREVIEW_DESIGN = "report_preview_design";
}
